const communicator = {
  login: {
    subtitle: 'Conecte sua identidade do chat à sua conta Prodgy',
    missingToken: 'Token de autenticação inválido ou ausente. Use /prodgy login no seu chat para gerar um novo link.',
    authRequired: 'Autenticação Necessária',
    authRequiredDescription: 'Você precisa fazer login na sua conta Prodgy para completar a vinculação. Clique no botão abaixo para entrar.',
    goToLogin: 'Entrar no Prodgy',
    confirming: 'Vinculando sua conta...',
    confirmFailed: 'Falha ao vincular sua conta. O token pode ter expirado. Use /prodgy login para gerar um novo link.',
    success: 'Conta Vinculada!',
    successDescription: 'Sua identidade do chat foi conectada à sua conta Prodgy. Agora use /prodgy link <slug> para selecionar um workspace.',
    canCloseTab: 'Você pode fechar esta aba e voltar ao seu chat.',
    errorTitle: 'Falha na Vinculação',
    goHome: 'Ir para o Prodgy',
  },
};

export default communicator;
